import ScreenDimensions from '@utilities/screen-dimensions';
import RafThrottle from '@utilities/raf-throttle';

const PRODUCT_DETAIL_STICKY_HOOK = '[js-hook-product-detail-sticky]';
const PRODUCT_DETAIL_CONTENT_WRAPPER_HOOK = '[js-hook-product-detail-content-wrapper]';
const HEADER_HEIGHT = 80;

class ProductDetailHero {
  constructor(element) {
    this.element = element;
    this.stickyEl = this.element.querySelector(PRODUCT_DETAIL_STICKY_HOOK);
    this.contentWrapperEl = this.element.querySelector(PRODUCT_DETAIL_CONTENT_WRAPPER_HOOK);

    this.updateStickyElPosition();
    this.bindEvents();
  }

  bindEvents() {
    RafThrottle.set([
      {
        element: window,
        event: 'resize',
        namespace: `UpdateStickyElementPositioning`,
        fn: () => this.updateStickyElPosition(),
        delay: 250,
      },
    ])
  }

  updateStickyElPosition() {
    const windowHeight = window.innerHeight - HEADER_HEIGHT;
    const contentHeight = this.contentWrapperEl.offsetHeight;
    const heightDifference = windowHeight - contentHeight;

    if (heightDifference < 0 && ScreenDimensions.isTabletLandscapeAndBigger ) {
      this.stickyEl.style.top =  `${heightDifference + HEADER_HEIGHT}px`;
    } else {
      this.stickyEl.removeAttr('style');
    }
  }
}

export default ProductDetailHero;
